import React, { Suspense } from "react"
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom"

import { AuthProvider } from "./Context/AuthContext"
import AuthGuard from "./Components/auth/AuthGuard"
import GuestGuard from "./Components/auth/GuestGuard"
import BookingList from "./pages/BookingList"
import BookingDetail from "./pages/BookingDetail"
import BlackoutDates from "./pages/BlackoutDates"
import Login from "./pages/Login"
import NotFound from "../Common/Components/NotFound"
import Loading from "../Common/Components/Loading"

// ルートレイアウト：AuthProviderでラップ
const RootLayout: React.FC = () => {
    return (
        <AuthProvider>
            <Outlet />
        </AuthProvider>
    )
}

const Routing: React.FC = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <RootLayout />,
            errorElement: <NotFound />,
            children: [
                // ログインページ（ゲスト専用）
                {
                    path: "/login",
                    element: (
                        <GuestGuard>
                            <Suspense fallback={<Loading />}>
                                <Login />
                            </Suspense>
                        </GuestGuard>
                    )
                },
                // 認証が必要なページ
                {
                    path: "/",
                    element: (
                        <AuthGuard>
                            <Suspense fallback={<Loading />}>
                                <BookingList />
                            </Suspense>
                        </AuthGuard>
                    )
                },
                {
                    path: "/bookings/:id",
                    element: (
                        <AuthGuard>
                            <Suspense fallback={<Loading />}>
                                <BookingDetail />
                            </Suspense>
                        </AuthGuard>
                    )
                },
                {
                    path: "/blackout-dates",
                    element: (
                        <AuthGuard>
                            <Suspense fallback={<Loading />}>
                                <BlackoutDates />
                            </Suspense>
                        </AuthGuard>
                    )
                }
            ]
        }
    ],
    {
        basename: "/main"
    })

    return <RouterProvider router={router} />
}

export default Routing
